<ul id="process-menu">
    @for (item of menu; track item) {
        <li #listElement>
            {{ item.text | t }}
        </li>
        <cerrix-contextmenu
            [menu]="item.menu"
            [elementClickToggle]="listElement"
            theme="processeditor"
        ></cerrix-contextmenu>
    }
</ul>
